export const normalizeFullName = (value) => String(value || '').replace(/\s+/g, ' ').trim();
export const profileInitials = (name) => {
  const words = normalizeFullName(name).split(' ').filter((word) => word && !/^(dr|mr|mrs|ms|prof|sir|jr|sr|ii|iii|iv)\.?$/i.test(word));
  if (!words.length) return '?';
  return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase();
};
